import { BaseDocument } from '../types';
import { DocumentHandler } from '../data/document-handler.interface';
import { DesignDocument } from '../data/design-document.interface';

/**
 * Abstrakte Basis-Implementierung von DocumentHandler.
 * Reduziert die Pflichtmethoden von 7 auf 2:
 * - getDesignDocuments() — CouchDB Views/Filter
 * - createNew() — Factory für neue Dokumente
 *
 * Die übrigen 5 Methoden haben sinnvolle Defaults.
 */
export abstract class BaseDocumentHandler<T extends BaseDocument> implements DocumentHandler<T> {

	/** ABSTRAKT: Liefert Design-Dokumente (CouchDB Views und Filter). */
	abstract getDesignDocuments(): DesignDocument[];

	/** ABSTRAKT: Erstellt ein neues Dokument mit Default-Werten. */
	abstract createNew(partial?: Partial<T>): T;

	/** Default: Gibt das Roh-Dokument unverändert zurück. */
	transformAfterLoad(raw: any): T {
		return raw as T;
	}

	/** Default: Kein Enrichment. */
	enrichDocument(_doc: T): void { }

	/** Default: Alle Dokumente liegen in jeder Region. */
	isDocumentInRegion(_doc: T, _region: any): boolean {
		return true;
	}

	/** Default: Gibt das Dokument unverändert zurück. */
	transformForSave(doc: T): T {
		return doc;
	}

	/** Default: Keine hardcodierten Lookup-Daten. */
	getHardData(): Map<string, any[]> {
		return new Map();
	}
}
